import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './utils/useAuth';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Pending from './pages/Pending';
import AdminUsers from './pages/AdminUsers';
import CoachDashboard from './pages/CoachDashboard';
import AddGame from './pages/AddGame';
import EditGame from "./pages/EditGame";
import GameDetails from "./pages/GameDetails";
import ManageFields from "./pages/ManageFields";
import CompetitionRequest from "./pages/CompetitionRequest";
import CoachNotifications from "./pages/CoachNotifications";
import ManagerDashboard from './pages/ManagerDashboard';
import ManagerReferees from './pages/ManagerReferees';
import ManagerApprovals from './pages/ManagerApprovals';
import ManagerBilling from './pages/ManagerBilling';
import ManagerCompetitions from './pages/ManagerCompetitions';
import ManagerNotifications from './pages/ManagerNotifications';
import ManagerCalendar from './pages/ManagerCalendar';
import RefereeDashboard from './pages/RefereeDashboard';
import Navbar from './components/Navbar';
import Profile from './pages/Profile';
import Protected from "./components/Protected";
import RefereeProfile from "./pages/RefereeProfile";
import RefereeAvailability from "./pages/RefereeAvailability";
import RefereeMatchFees from "./pages/RefereeMatchFees";
import RefereeCalendar from "./pages/RefereeCalendar";
import RefereeNotifications from "./pages/RefereeNotifications";
import InstallPrompt from "./components/InstallPrompt";



export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/Screenshot%202026-01-15%20at%2015.04.07.png)`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          backgroundSize: 'contain',
          opacity: 0.1,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
          pointerEvents: 'none'
        }} />
        <Navbar />
        <InstallPrompt />
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/pending' element={<Pending />} />

          {/* Admin */}
          <Route path='/admin/users' element={<Protected role='admin'><AdminUsers/></Protected>} />

          {/* Manager */}
          <Route path='/manager' element={<Protected role='manager'><ManagerDashboard/></Protected>} />
          <Route path='/manager/add-game' element={<Protected role='manager'><AddGame/></Protected>} />
          <Route path='/manager/calendar' element={<Protected role='manager'><ManagerCalendar/></Protected>} />
          <Route path='/manager/referees' element={<Protected role='manager'><ManagerReferees/></Protected>} />
          <Route path='/manager/approvals' element={<Protected role='manager'><ManagerApprovals/></Protected>} />
          <Route path='/manager/competitions' element={<Protected role='manager'><ManagerCompetitions/></Protected>} />
          <Route path='/manager/billing' element={<Protected role='manager'><ManagerBilling/></Protected>} />
          <Route path='/manager/notifications' element={<Protected role='manager'><ManagerNotifications/></Protected>} />

          {/* Coach */}
          <Route path='/coach' element={<Protected role='coach'><CoachDashboard/></Protected>} />
          <Route path='/add-game' element={<Protected role='coach'><AddGame/></Protected>} />
          <Route path='/manage-fields' element={<Protected role='coach'><ManageFields/></Protected>} />
          <Route path='/competition-request' element={<Protected role='coach'><CompetitionRequest/></Protected>} />
          <Route path='/coach/notifications' element={<Protected role='coach'><CoachNotifications/></Protected>} />
          <Route path="/game/:id" element={<Protected><GameDetails /></Protected>}/>


          {/* Referee */}
          <Route path='/ref' element={<Protected role='referee'><RefereeDashboard/></Protected>} />
          <Route path='/ref/calendar' element={<Protected role='referee'><RefereeCalendar/></Protected>} />
          <Route path="/edit-game/:id" element={<Protected role="coach"><EditGame /></Protected>}/>
          <Route path="/ref/profile" element={<Protected role="referee"><RefereeProfile/></Protected>}/>
          <Route path="/ref/availability" element={<Protected role="referee"><RefereeAvailability /></Protected>}/>
          <Route path="/ref/match-fees" element={<Protected role="referee"><RefereeMatchFees /></Protected>}/>
          <Route path="/ref/notifications" element={<Protected role="referee"><RefereeNotifications /></Protected>}/>

          {/* All authenticated users */}
          <Route path='/profile' element={<Protected><Profile /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
